import { useTheme } from '@mui/material';
import Typography from '@mui/material/Typography/Typography';
import { useAuthContext } from '../../../context/AuthContextProvider';
import { getUserName } from '../../../models/User';
import { UserTabs } from '../UserTabPanel';
import { CardTabs, CoverCard, UserAvatar, UserAvatarWrapper } from './styles';

export const UserCoverComponent = () => {
  const theme = useTheme();

  const { user: userAuth } = useAuthContext();
  const userName = getUserName(userAuth!);
  const userInitials = userName
    .split(' ')
    .map((n) => n.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('');

  return (
    <CoverCard sx={{ mt: 4 }}>
      <UserAvatarWrapper>
        <UserAvatar alt={userName} className="user-image">
          {userInitials}
        </UserAvatar>
        <Typography variant="h4" mt={1} color={theme.palette.common.white}>
          {userAuth && getUserName(userAuth)}
        </Typography>
      </UserAvatarWrapper>
      <CardTabs>
        <UserTabs />
      </CardTabs>
    </CoverCard>
  );
};
